import React, { useState, useCallback, useEffect } from "react";
import { Container, Row, Col, Modal } from "reactstrap";
import MetaTags from "react-meta-tags";
import handleExportCSV from "pages/utils/handleExportCSV";
import Datatables from "pages/table/datatable";
import { tableColumns } from "./components/TableColumns";
import { universalTemplatesData } from "AllDummyData/DummyData";
import StatsCard from "./components/StatsCard";
import FilterBar from "./components/FilterBar";
import { ToastAlertsNotification } from "pages/utils/Alerts/ToastsAlertMessages";
import { checklistOptionsTableData } from "AllDummyData/DummyData";
import { InputField, SelectField } from "pages/InputFields/InputFields";
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"

import { get } from "helpers/api_helper";

const emptyRow = () => ({
    id: Date.now() + Math.random(), title: "", active_relative_to: null, timings: null,
    days: "", assigned_to: null, notes: "", email_subject_line: "", email_body: "", type: "task"
});

const UniversalTemplates = () => {
    const toast = ToastAlertsNotification();
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMode, setModalMode] = useState("Add"); // "Add", "View", or "Edit"
    const [selectedData, setSelectedData] = useState(null);
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [formData, setFormData] = useState([emptyRow()]);
    const [formType, setFormType] = useState("task");
    const [templatesList, setTemplatesList] = useState(universalTemplatesData);

    useEffect(() => {
        const fetchTemplates = async () => {
            try {
                const res = await get("/superadmin/universal-templates");
                const list = res?.data || res;
                if (Array.isArray(list) && list.length > 0) {
                    const formatted = list.map((t, idx) => ({
                        id: t.template_id || idx + 1,
                        title: t.template_title || "Universal Template #" + (t.template_id || idx + 1),
                        template_for: t.template_for || "Buyer",
                        template_stage: t.template_stage || "Under Contract",
                        status: t.status === 0 ? "Active" : "Inactive",
                        steps_count: Array.isArray(t.UniversalChecklistSteps) ? t.UniversalChecklistSteps.length : 0,
                    }));
                    setTemplatesList(formatted);
                }
            } catch (e) {
                console.warn("Using fallback templates data", e);
            }
        };
        fetchTemplates();
    }, []);


    const toggleModal = useCallback(() => {
        setModalOpen(!modalOpen);
        if (modalOpen) setSelectedData(null); // Clear selection on close
    }, [modalOpen]);

    const handleChange = e => {
        const { name, value } = e.target
        setFormData(prev => ({ ...prev, [name]: value }))
    }

    const handleSubmit = async () => {
        const { title, active_relative_to, timings, days, assigned_to, notes, email_subject_line, email_body, type } = formData;

        if (!title || !active_relative_to || !timings || !days || !assigned_to || !notes || !email_subject_line || !email_body || !type) {
            toast.error("Please fill the required fields.");
            return;
        }
        console.log("Submitted Form :", formData);
        toast.success("Client created successfully!");
        setFormData({});
        toggleModal();
        setFormType("task")

        // console.log("Submitted Form :", formData)
        // const url = editMode ? `${CONTACT_URL}/${editingId}` : CONTACT_URL
        // const response = await (editMode ? put : post)(url, formData)
        // console.log("Submitted Form :", response)
        // if (response?.success) {
        //     showSuccessAlert("Client created successfully!")
        //     setFormData({})
        //     // setEditMode(false)
        //     // setEditingId(null)
        //     // fetchData()
        //     toggleModal()
        // }
    }

    const handleAction = (mode, client = null) => {
        setModalMode(mode);
        setSelectedData(client);
        setFormType("task")

        if (mode === "Edit" && client) {
            setFormData({});
            setFormType("task")
        }
        setModalOpen(true);
        setFormData([emptyRow()]);
        setFormType("task");
    };

    // --- Calculations ---
    const isAnySelected = selectedRowIds.length > 0;

    return (
        <React.Fragment>
            <div className="dash-page ms-4 me-4">
                <MetaTags>
                    <title>Universal Templates | {process.env.REACT_APP_TITLE}</title>
                </MetaTags>
                <Container fluid>
                    <div className="p-3">
                        <Row className="align-items-center mb-4">
                            <Col md="4">
                                <h4 className="mb-0 fw-bolder">Universal Templates</h4>
                            </Col>
                            <Col md="8" className="d-flex justify-content-end gap-2">
                                {isAnySelected && (
                                    <>
                                        <button className="btn btn-danger border px-3 animate__animated animate__fadeIn" style={{ minWidth: "130px" }}
                                            onClick={() => handleAction("Delete")}>
                                            <i className="bx bx-trash me-1"></i> Delete ({selectedRowIds.length})
                                        </button>
                                        <button className="btn btn-success border px-3 animate__animated animate__fadeIn" style={{ minWidth: "130px" }}
                                            onClick={handleExportCSV}>
                                            <i className="bx bx-export me-1"></i> Export All ({selectedRowIds.length})
                                        </button>
                                    </>
                                )}
                                <button className="btn btn-primary border px-3 animate__animated animate__fadeIn" style={{ minWidth: "130px" }}
                                    onClick={() => handleAction("Add")}>
                                    <i className="bx bx-plus me-1"></i> New Template
                                </button>
                            </Col>
                        </Row>

                        <StatsCard />

                        <FilterBar />

                        <div className="p-3 bg-white shadow-sm border" style={{ borderRadius: "10px" }}>
                            <Datatables
                                columns={tableColumns(handleAction)}
                                showTableOnly={true}
                                rows={templatesList}
                                keyField="title"
                                isCheckbox={true}
                                loading={false}
                                setSelectedRowIds={setSelectedRowIds}
                            />
                        </div>
                    </div>

                    <Modal isOpen={modalOpen} toggle={toggleModal} style={{ maxWidth: "800px" }} className="custom-modal">
                        <div className="modal-header">
                            <h5 className="modal-title fw-bold mb-1">{`${modalMode} ${selectedData ? selectedData?.title : 'Company'}`}</h5>
                            <button type="button" onClick={toggleModal} className="close" aria-label="Close"></button>
                        </div>

                        <div className="modal-body">
                            {modalMode === "View" && selectedData ? (
                                <>
                                    <div className="text-center p-3">
                                        <div className="avatar-md mx-auto mb-3">
                                            <span className="avatar-title rounded-circle bg-primary-subtle text-primary h2">
                                                {selectedData.title.charAt(0)}
                                            </span>
                                        </div>
                                        <h5 className="mb-1">{selectedData.title}</h5>
                                        <p className="text-muted"><strong>Assigned To:</strong> {selectedData.assigned_to}</p>
                                        <hr />
                                        <Row className="text-start">
                                            <Col xs="6" className="mb-2"><strong>Timings:</strong> {selectedData.timings}</Col>
                                            <Col xs="6" className="mb-2"><strong>Days:</strong> {selectedData.days}</Col>
                                        </Row>
                                        <Row className="text-start">
                                            <Col xs="6" className="mb-2"><strong>Active Relative To:</strong> {selectedData.active_relative_to}</Col>
                                            <Col xs="6" className="mb-2"><strong>Status:</strong> {selectedData.status}</Col>
                                        </Row>
                                    </div>
                                    <div className="d-flex justify-content-end gap-2 mt-4">
                                        <button className="btn btn-danger" style={{ width: "100px" }} onClick={toggleModal}>Close</button>
                                    </div>
                                </>
                            ) : (
                                <div className="p-2">
                                    <Row className="g-3">
                                        <Col md="12" className="mb-2">
                                            <button type="button" className={`btn me-3 w-25 ${formType === "task" ? "btn-primary" : "btn-outline-primary"}`}
                                                onClick={() => { setFormType("task"); setFormData(prev => ({ ...prev, type: "task" })); }}>
                                                Task
                                            </button>

                                            <button type="button" className={`btn w-25 ${formType === "email" ? "btn-primary" : "btn-outline-primary"}`}
                                                onClick={() => { setFormType("email"); setFormData(prev => ({ ...prev, type: "email" })); }}>
                                                Email
                                            </button>
                                        </Col>

                                        <Col md="6">
                                            <InputField label="Template Title" name="title" type="text"
                                                onChange={handleChange} value={formData.title} placeholder="Enter template title" />
                                        </Col>

                                        <Col md="6">
                                            <InputField label="Number of Days" name="days" type="number"
                                                onChange={handleChange} value={formData.days} placeholder="Enter number of days" />
                                        </Col>
                                        <Col md="6">
                                            <SelectField label="Timings" name="timings" value={formData.timings} isClearable={true} placeholder="Select Timings"
                                                onChange={(option) => setFormData(prev => ({ ...prev, timings: option || null }))}
                                                options={[
                                                    { value: "before", label: "Before" },
                                                    { value: "after", label: "After" },
                                                ]}
                                            />
                                        </Col>
                                        <Col md="6">
                                            <SelectField label="Action Relative To" name="active_relative_to" value={formData.active_relative_to} isClearable={true} placeholder="Select Timings"
                                                onChange={(option) => setFormData(prev => ({ ...prev, active_relative_to: option || null }))}
                                                options={checklistOptionsTableData}
                                            />
                                        </Col>
                                        <Col md="12">
                                            <SelectField label="Assigned To" name="assigned_to" value={formData.assigned_to} isClearable={true} placeholder="Select Agents"
                                                onChange={(option) => setFormData(prev => ({ ...prev, assigned_to: option || null }))} isMulti={true}
                                                options={checklistOptionsTableData}
                                            />
                                            <small style={{ color: "red" }}>Team Members or User API need to call here</small>
                                        </Col>
                                        {formData.type === "email" && (
                                            <>
                                                <Col md="12">
                                                    <InputField label="Email Subject Line" name="email_subject_line" type="text"
                                                        onChange={handleChange} value={formData.email_subject_line} placeholder="Enter email subject line" />
                                                </Col>

                                                <Col md="12">
                                                    <SelectField label="TO" name="email_to" value={formData.email_to} isClearable={true} placeholder="Select Agents"
                                                        onChange={(option) => setFormData(prev => ({ ...prev, email_to: option || null }))} isMulti={true}
                                                        options={checklistOptionsTableData}
                                                    />
                                                    <small style={{ color: "red" }}>Team Members or User API need to call here</small>
                                                </Col>
                                                <Col md="12">
                                                    <SelectField label="CC" name="email_cc" value={formData.email_cc} isClearable={true} placeholder="Select Agents"
                                                        onChange={(option) => setFormData(prev => ({ ...prev, email_cc: option || null }))} isMulti={true}
                                                        options={checklistOptionsTableData}
                                                    />
                                                    <small style={{ color: "red" }}>Team Members or User API need to call here</small>
                                                </Col>
                                                <Col md="12">
                                                    <label className="form-label">Email Body</label>
                                                    <Editor toolbarClassName="toolbarClassName" wrapperClassName="wrapperClassName" editorClassName="editorClassName" />
                                                </Col>
                                                <hr />
                                            </>
                                        )}
                                        <Col md="12">
                                            <label>Notes</label>
                                            <textarea rows="3" className="form-control" value={formData.notes}
                                                onChange={handleChange} placeholder="Notes..." style={{ resize: "none" }}
                                            />
                                        </Col>

                                    </Row>
                                    <div className="d-flex justify-content-end gap-2 mt-4">
                                        <button className="btn btn-danger" style={{ width: "100px" }} onClick={toggleModal}>Cancel</button>
                                        <button className="btn btn-primary px-4" onClick={handleSubmit} style={{ width: `${modalMode === "Add" ? "110px" : "140px"}` }}>
                                            {modalMode === "Add" ? "Create" : "Save Changes"}</button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Modal>

                </Container>
            </div>
        </React.Fragment>
    );
};

export default UniversalTemplates;